<template>
  <section>
    <div v-for="d in data" :key="d.id" class="mt-4">
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <Avatar
            :classStr="'h-8 w-8 mr-2'"
            :src="baseUrlSrc(d.user.thumbnail_url)"
          />
          <div>
            <p class="capitalize text-sm text-gray-dark">{{ d.user.name }}</p>
            <p class="text-sm text-gray-dark -mt-1">
              {{ handleCreatedAt(d.created_at) }}
            </p>
          </div>
        </div>
        <div class="flex">
          <button
            v-if="getToken() && d.user.id == user.id"
            class="px-2"
            @click="handleTrashClick(d.id)"
          >
            <Trash />
          </button>
        </div>
      </div>
      <div class="mt-4">
        <p class="text-xs text-gray-700">
          <span class="text-xs font-bold bg-gray-200" v-if="d.tagged_user">{{
            handleUserName(d.tagged_user.name)
          }}</span>
          {{ d.body }}
        </p>
        <div class="flex items-center text-xs mt-2">
          <button
            v-if="getToken()"
            @click="handleReplyBoxOpen(d.id)"
            class="text-xs text-gray-dark"
          >
            Reply
          </button>
        </div>
        <section v-if="isReplyBoxOpen[d.id]" class="mt-4">
          <span class="text-xs font-bold bg-gray-200">{{
            handleUserName(d.user.name)
          }}</span>
          <div class="flex">
            <Avatar
              :classStr="'h-10 w-10 mr-2 mt-2'"
              :src="baseUrlSrc(d.user.thumbnail_url)"
            />
            <div class="w-full">
              <div>
                <label class="block">
                  <textarea
                    class="form-textarea mt-1 block w-full bg-gray-280 text-sm text-gray-light"
                    rows="3"
                    :class="{ 'border-red-500': $v.body.$error }"
                    placeholder="Post your reply here..."
                    v-model="$v.body.$model"
                  ></textarea>
                </label>
                <div v-if="$v.body.$error">
                  <small class="text-red-500" v-if="!$v.body.required">
                    Description field is required.
                  </small>
                  <small class="text-red-500" v-if="!$v.body.minLength">
                    Description must have at least 10 letters.
                  </small>
                  <small class="text-red-500" v-if="!$v.body.maxLength">
                    Description must have at most 100 letters.
                  </small>
                </div>
              </div>
              <div class="mt-2 float-right">
                <button
                  class="text-green-light px-2 text-sm py-1"
                  @click="handleReplyBoxOpen(d.id)"
                >
                  Cancel
                </button>
                <button
                  class="text-white bg-green-light rounded text-sm px-2 py-1"
                  @click.prevent="
                    handleReplyClick(d.parent_id, d.user.id, d.id)
                  "
                >
                  Reply
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { Avatar } from "@/components/t-components";
import { Trash } from "@/components/icons";
import { mapActions } from "vuex";

export default {
  components: {
    Avatar,
    Trash,
  },
  props: {
    data: Array,
  },
  data() {
    return {
      body: "",
      isReplyBoxOpen: [],
      isReplyOpen: false,
      user: JSON.parse(localStorage.getItem("user")),
    };
  },
  validations: {
    body: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(100),
    },
  },
  methods: {
    ...mapActions(["trainerPostDelete", "postComment", "commentDelete"]),

    handleReplyClick(parent_id, user_id, id) {
      this.$v.body.$touch();
      if (!this.$v.body.$invalid) {
        const data = {
          post_id: this.$route.params.id,
          parent_id: parent_id,
          tagged_user_id: user_id,
          body: this.body,
        };
        this.postComment(data);
        var obj = {};
        obj[id] = false;
        this.isReplyBoxOpen = obj;
      }
      this.$emit("reply", true);
    },

    handleTrashClick(id) {
      var c = confirm("Are you sure?");
      if (c) {
        this.commentDelete(id);
        const index = this.data.findIndex((e) => e.id === id);
        if (index !== -1) {
          this.data.splice(index, 1);
        }
      }
    },

    handleReplyBoxOpen(id) {
      var obj = {};
      obj[id] = !this.isReplyBoxOpen[id];
      this.isReplyBoxOpen = obj;
    },
  },
};
</script>